import request from "@/utils/request";

export function getPage(condition, pagination) {
  return request({
    url: "/sales/loan/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function saveOrUpdate(data) {
    return request({
      url: "/sales/loan/saveOrUpdate",
      method: "post",
      data,
    });
  }
  
  export function get(id) {
    return request({
      url: "/sales/loan/get",
      method: "get",
      params: { id },
    });
  }
export function deleteById(id) {
    return request({
      url: "/sales/loan/deleteById",
      method: "post",
      data: { id: id },
    });
  }
  // 根据销售组织返回客户
  export function getByCustomerApply(data) {
    return request({
      url: "/customer/customerApply/getByCustomerApply",
      method: "post",
      data
    });
  }
  // 根据销售组织查询中间公司
  export function getByMiddleCompany(data) {
    return request({
      url: "/base/company/getByCompanyOfTransaction",
      method: "post",
      data
    });
  }
  // 
  export function submit(id) {
    return request({
      url: "/sales/loan/submit",
      method: "post",
      data: { id: id },
    });
  }
    // 根据销售组织查询中间公司
    export function getByOrdersOfDelivery(data) {
      return request({
        url: "/sales/loan/getByOrdersOfDelivery",
        method: "post",
        data
      });
    }
    // 
    export function getDetailPage(condition, pagination) {
      return request({
        url: "/crm/delivery/detailPage",
        method: "post",
        data: { condition: condition, pagination: pagination },
      });
    }
    
